import React from "react";
import logoImg from "../../../assets/images/logo.png";
const FooterPage = () => {
  return <footer></footer>;
};
export default FooterPage;
